import { numberOrZero } from "@/utils/utils";
import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import { percentageChange } from "../../../../utils";
import styles from "../../statistics/DashboardStatisticsWidget.module.scss";
import { StatNumber } from "./common/StatNumber";
import { TrendIndicator } from "./common/TrendIndicator";
import { STATS_HEIGHT } from "./common/utils";

type Props = {
  data: { traineesCount: number; previousTraineesCount?: number };
};

export const TraineesData = ({ data }: Props) => {
  const { t } = useTranslation();

  const statChange = percentageChange(data.traineesCount, numberOrZero(data.previousTraineesCount));

  return (
    <>
      <Flex align="center">
        <Button className={styles.labelIcon} variant="filled" color="magenta" icon={<AntIcon type="fund-view" />} />

        <div>
          <span className="margin-left-tiny margin-right-tiny" style={{ fontSize: 21 }}>
            {t("dashboard.statisticsExtended.trainees")}
          </span>

          <TrendIndicator value={statChange} />
        </div>
      </Flex>

      <Flex justify="center" className="margin-top-medium" style={{ height: STATS_HEIGHT }}>
        <StatNumber value={data.traineesCount} />
      </Flex>
    </>
  );
};
